/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import * as React from 'react';
import cx from 'classnames';

import styles from './MapControlButton.module.scss';

export interface MapControlButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    shape?: 'circle' | 'square' | 'pill';
    hasShadow?: boolean;
    hasInsetFocus?: boolean;
    gaTrackingId?: string;
    gaTrackingValue?: string;
}

export function MapControlButton({
    children,
    className,
    shape = 'circle',
    hasShadow = true,
    hasInsetFocus,
    gaTrackingId,
    gaTrackingValue,
    ...rest
}: MapControlButtonProps) {
    return (
        <button
            type="button"
            data-component="map-control-button"
            data-ga-tracking-id={gaTrackingId}
            data-ga-tracking-value={gaTrackingValue}
            className={cx(styles.root, className, {
                [styles.circle]: shape === 'circle',
                [styles.square]: shape === 'square',
                [styles.pill]: shape === 'pill',
                [styles.hasShadow]: hasShadow,
                [styles.hasInsetFocus]: hasInsetFocus,
            })}
            {...rest}
        >
            <span className={styles.inner}>{children}</span>
        </button>
    );
}
